<div style="width: 100%;">
  <button class="backBtn" mat-button (click)="goToDashboard()"><mat-icon slot="start">arrow_back</mat-icon> Zpět</button>
  <button class="backBtn" style="float:right;" mat-flat-button (click)="quickAnonymize()"><mat-icon slot="end">person_remove</mat-icon> Anonymizovat uživatele</button>
</div>

<div class="content">
  <div class="content-window">
    <mat-card class="settings-card detail-card" appearance="outlined">
      <mat-card-header>
        <mat-card-title>
          <mat-icon slot="start">account_circle</mat-icon>
          Detail uživatele
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>

        @for (item of data.respondentData | keyvalue; track item.key) {
          <p><strong>{{item.key}}</strong>: {{item.value}}</p>
        }
      </mat-card-content>
    </mat-card><br>
  </div>
  <h2 class="header"><mat-icon slot="start">inventory</mat-icon>
    Aktivity uživatele</h2>
  <div class="content-window">

    @for (item of data.activities; track item.aid) {
      <mat-card class="settings-card" appearance="outlined">
        <mat-card-header>
          <mat-card-title>
            {{item.name}}
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          @for (i of item | keyvalue; track i.key) {
            <p><strong>{{i.key}}: </strong>{{i.value}}</p>
          }
        </mat-card-content>
      </mat-card>
    }
  </div>
</div>
